import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions } from './firebase'
import { enqueueDeferredEvent } from './deferredEventOutbox'
import type { IntegrationProviderId, IntegrationReadinessCode } from '../types/integration'

const callable = <Input, Output>(name: string) => httpsCallable<Input, Output>(firebaseFunctions, name)

export const checkIntegrationReadiness = async (input: {
  workspaceId: string
  providerId: IntegrationProviderId
  connectionId?: string
  forceRefresh?: boolean
}) => {
  const result = await callable<typeof input, { isReady: boolean; connectionId: string | null; statusCode: IntegrationReadinessCode }>('getIntegrationReadiness')(input)
  return result.data
}

export const recordIntegrationGateHit = async (input: {
  workspaceId: string
  providerId: IntegrationProviderId
  actionKey: string
}) => {
  const queued = await enqueueDeferredEvent({
    actionKey: 'INTEGRATION_GATE_HIT',
    kind: 'INTEGRATION',
    payload: input,
  })
  if (queued) return
  await callable<typeof input, { recorded: boolean }>('recordIntegrationGateHit')(input)
}

export const recordAutomationIntegrationMissing = async (input: {
  workspaceId: string
  providerId: IntegrationProviderId
  actionKey: string
  automationId: string
}) => {
  const queued = await enqueueDeferredEvent({
    actionKey: 'INTEGRATION_MISSING',
    kind: 'INTEGRATION',
    payload: input,
  })
  if (queued) return
  await callable<typeof input, { recorded: boolean }>('recordIntegrationMissing')(input)
}

export const encodeGatewayReturnTo = (path: string) => {
  const bytes = new TextEncoder().encode(path)
  let binary = ''
  bytes.forEach((byte) => { binary += String.fromCharCode(byte) })
  return btoa(binary)
}

export const buildLinkGatewayUrl = (workspaceSlug: string, providerId: IntegrationProviderId, returnTo: string) => {
  const query = new URLSearchParams({ providerId, returnTo: encodeGatewayReturnTo(returnTo) })
  return `/workspace/${encodeURIComponent(workspaceSlug)}/link?${query.toString()}`
}
